// Intl-based, locale-aware formatters for the public Case Status pages.
// `locale` is a BCP-47 culture (e.g. 'nb-no', 'sv-se', 'en-us') — use toBackendCulture(language).

export function formatCurrency(amount: number | string, currency: string, locale: string): string {
  const value = typeof amount === 'string' ? Number(amount) : amount;
  if (!Number.isFinite(value)) return `${amount} ${currency}`.trim();
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);
  } catch {
    return `${value} ${currency}`.trim();
  }
}

export function formatDate(isoDate: string | null | undefined, locale: string): string {
  if (!isoDate) return '';
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return isoDate;
  try {
    return new Intl.DateTimeFormat(locale).format(date);
  } catch {
    return isoDate;
  }
}
